/**
 * Country name + ISO2 + international dialing code.
 *
 * Names/order intentionally match Profile.jsx's own COUNTRIES list (same
 * bulk-MT-eligible, English-only list) so a country picked during onboarding
 * lines up with the exact option Profile's own country <select> expects —
 * no separate/drifting country vocabulary between the two screens.
 */
export const COUNTRIES = [
  { name: "Afghanistan", iso2: "AF", dial: "+93" },
  { name: "Albania", iso2: "AL", dial: "+355" },
  { name: "Algeria", iso2: "DZ", dial: "+213" },
  { name: "American Samoa", iso2: "AS", dial: "+1" },
  { name: "Andorra", iso2: "AD", dial: "+376" },
  { name: "Angola", iso2: "AO", dial: "+244" },
  { name: "Anguilla", iso2: "AI", dial: "+1" },
  { name: "Antigua and Barbuda", iso2: "AG", dial: "+1" },
  { name: "Argentina", iso2: "AR", dial: "+54" },
  { name: "Armenia", iso2: "AM", dial: "+374" },
  { name: "Aruba", iso2: "AW", dial: "+297" },
  { name: "Australia", iso2: "AU", dial: "+61" },
  { name: "Austria", iso2: "AT", dial: "+43" },
  { name: "Azerbaijan", iso2: "AZ", dial: "+994" },
  { name: "Bahamas", iso2: "BS", dial: "+1" },
  { name: "Bahrain", iso2: "BH", dial: "+973" },
  { name: "Bangladesh", iso2: "BD", dial: "+880" },
  { name: "Barbados", iso2: "BB", dial: "+1" },
  { name: "Belarus", iso2: "BY", dial: "+375" },
  { name: "Belgium", iso2: "BE", dial: "+32" },
  { name: "Belize", iso2: "BZ", dial: "+501" },
  { name: "Benin", iso2: "BJ", dial: "+229" },
  { name: "Bermuda", iso2: "BM", dial: "+1" },
  { name: "Bhutan", iso2: "BT", dial: "+975" },
  { name: "Bolivia", iso2: "BO", dial: "+591" },
  { name: "Bosnia and Herzegovina", iso2: "BA", dial: "+387" },
  { name: "Botswana", iso2: "BW", dial: "+267" },
  { name: "Brazil", iso2: "BR", dial: "+55" },
  { name: "British Virgin Islands", iso2: "VG", dial: "+1" },
  { name: "Brunei", iso2: "BN", dial: "+673" },
  { name: "Bulgaria", iso2: "BG", dial: "+359" },
  { name: "Burkina Faso", iso2: "BF", dial: "+226" },
  { name: "Burundi", iso2: "BI", dial: "+257" },
  { name: "Cabo Verde", iso2: "CV", dial: "+238" },
  { name: "Cambodia", iso2: "KH", dial: "+855" },
  { name: "Cameroon", iso2: "CM", dial: "+237" },
  { name: "Canada", iso2: "CA", dial: "+1" },
  { name: "Cayman Islands", iso2: "KY", dial: "+1" },
  { name: "Central African Republic", iso2: "CF", dial: "+236" },
  { name: "Chad", iso2: "TD", dial: "+235" },
  { name: "Chile", iso2: "CL", dial: "+56" },
  { name: "China", iso2: "CN", dial: "+86" },
  { name: "Colombia", iso2: "CO", dial: "+57" },
  { name: "Comoros", iso2: "KM", dial: "+269" },
  { name: "Congo", iso2: "CG", dial: "+242" },
  { name: "Cook Islands", iso2: "CK", dial: "+682" },
  { name: "Costa Rica", iso2: "CR", dial: "+506" },
  { name: "Croatia", iso2: "HR", dial: "+385" },
  { name: "Cuba", iso2: "CU", dial: "+53" },
  { name: "Curaçao", iso2: "CW", dial: "+599" },
  { name: "Cyprus", iso2: "CY", dial: "+357" },
  { name: "Czech Republic", iso2: "CZ", dial: "+420" },
  { name: "Denmark", iso2: "DK", dial: "+45" },
  { name: "Djibouti", iso2: "DJ", dial: "+253" },
  { name: "Dominica", iso2: "DM", dial: "+1" },
  { name: "Dominican Republic", iso2: "DO", dial: "+1" },
  { name: "Ecuador", iso2: "EC", dial: "+593" },
  { name: "Egypt", iso2: "EG", dial: "+20" },
  { name: "El Salvador", iso2: "SV", dial: "+503" },
  { name: "Equatorial Guinea", iso2: "GQ", dial: "+240" },
  { name: "Eritrea", iso2: "ER", dial: "+291" },
  { name: "Estonia", iso2: "EE", dial: "+372" },
  { name: "Eswatini", iso2: "SZ", dial: "+268" },
  { name: "Ethiopia", iso2: "ET", dial: "+251" },
  { name: "Faroe Islands", iso2: "FO", dial: "+298" },
  { name: "Fiji", iso2: "FJ", dial: "+679" },
  { name: "Finland", iso2: "FI", dial: "+358" },
  { name: "France", iso2: "FR", dial: "+33" },
  { name: "French Guiana", iso2: "GF", dial: "+594" },
  { name: "French Polynesia", iso2: "PF", dial: "+689" },
  { name: "Gabon", iso2: "GA", dial: "+241" },
  { name: "Gambia", iso2: "GM", dial: "+220" },
  { name: "Georgia", iso2: "GE", dial: "+995" },
  { name: "Germany", iso2: "DE", dial: "+49" },
  { name: "Ghana", iso2: "GH", dial: "+233" },
  { name: "Gibraltar", iso2: "GI", dial: "+350" },
  { name: "Greece", iso2: "GR", dial: "+30" },
  { name: "Greenland", iso2: "GL", dial: "+299" },
  { name: "Grenada", iso2: "GD", dial: "+1" },
  { name: "Guadeloupe", iso2: "GP", dial: "+590" },
  { name: "Guam", iso2: "GU", dial: "+1" },
  { name: "Guatemala", iso2: "GT", dial: "+502" },
  { name: "Guernsey", iso2: "GG", dial: "+44" },
  { name: "Guinea", iso2: "GN", dial: "+224" },
  { name: "Guinea-Bissau", iso2: "GW", dial: "+245" },
  { name: "Guyana", iso2: "GY", dial: "+592" },
  { name: "Haiti", iso2: "HT", dial: "+509" },
  { name: "Honduras", iso2: "HN", dial: "+504" },
  { name: "Hong Kong", iso2: "HK", dial: "+852" },
  { name: "Hungary", iso2: "HU", dial: "+36" },
  { name: "Iceland", iso2: "IS", dial: "+354" },
  { name: "India", iso2: "IN", dial: "+91" },
  { name: "Indonesia", iso2: "ID", dial: "+62" },
  { name: "Iran", iso2: "IR", dial: "+98" },
  { name: "Iraq", iso2: "IQ", dial: "+964" },
  { name: "Ireland", iso2: "IE", dial: "+353" },
  { name: "Isle of Man", iso2: "IM", dial: "+44" },
  { name: "Israel", iso2: "IL", dial: "+972" },
  { name: "Italy", iso2: "IT", dial: "+39" },
  { name: "Jamaica", iso2: "JM", dial: "+1" },
  { name: "Japan", iso2: "JP", dial: "+81" },
  { name: "Jersey", iso2: "JE", dial: "+44" },
  { name: "Jordan", iso2: "JO", dial: "+962" },
  { name: "Kazakhstan", iso2: "KZ", dial: "+7" },
  { name: "Kenya", iso2: "KE", dial: "+254" },
  { name: "Kiribati", iso2: "KI", dial: "+686" },
  { name: "Kosovo", iso2: "XK", dial: "+383" },
  { name: "Kuwait", iso2: "KW", dial: "+965" },
  { name: "Kyrgyzstan", iso2: "KG", dial: "+996" },
  { name: "Laos", iso2: "LA", dial: "+856" },
  { name: "Latvia", iso2: "LV", dial: "+371" },
  { name: "Lebanon", iso2: "LB", dial: "+961" },
  { name: "Lesotho", iso2: "LS", dial: "+266" },
  { name: "Liberia", iso2: "LR", dial: "+231" },
  { name: "Libya", iso2: "LY", dial: "+218" },
  { name: "Liechtenstein", iso2: "LI", dial: "+423" },
  { name: "Lithuania", iso2: "LT", dial: "+370" },
  { name: "Luxembourg", iso2: "LU", dial: "+352" },
  { name: "Macau", iso2: "MO", dial: "+853" },
  { name: "Madagascar", iso2: "MG", dial: "+261" },
  { name: "Malawi", iso2: "MW", dial: "+265" },
  { name: "Malaysia", iso2: "MY", dial: "+60" },
  { name: "Maldives", iso2: "MV", dial: "+960" },
  { name: "Mali", iso2: "ML", dial: "+223" },
  { name: "Malta", iso2: "MT", dial: "+356" },
  { name: "Marshall Islands", iso2: "MH", dial: "+692" },
  { name: "Martinique", iso2: "MQ", dial: "+596" },
  { name: "Mauritania", iso2: "MR", dial: "+222" },
  { name: "Mauritius", iso2: "MU", dial: "+230" },
  { name: "Mayotte", iso2: "YT", dial: "+262" },
  { name: "Mexico", iso2: "MX", dial: "+52" },
  { name: "Micronesia", iso2: "FM", dial: "+691" },
  { name: "Moldova", iso2: "MD", dial: "+373" },
  { name: "Monaco", iso2: "MC", dial: "+377" },
  { name: "Mongolia", iso2: "MN", dial: "+976" },
  { name: "Montenegro", iso2: "ME", dial: "+382" },
  { name: "Montserrat", iso2: "MS", dial: "+1" },
  { name: "Morocco", iso2: "MA", dial: "+212" },
  { name: "Mozambique", iso2: "MZ", dial: "+258" },
  { name: "Myanmar", iso2: "MM", dial: "+95" },
  { name: "Namibia", iso2: "NA", dial: "+264" },
  { name: "Nauru", iso2: "NR", dial: "+674" },
  { name: "Nepal", iso2: "NP", dial: "+977" },
  { name: "Netherlands", iso2: "NL", dial: "+31" },
  { name: "New Caledonia", iso2: "NC", dial: "+687" },
  { name: "New Zealand", iso2: "NZ", dial: "+64" },
  { name: "Nicaragua", iso2: "NI", dial: "+505" },
  { name: "Niger", iso2: "NE", dial: "+227" },
  { name: "Nigeria", iso2: "NG", dial: "+234" },
  { name: "North Korea", iso2: "KP", dial: "+850" },
  { name: "North Macedonia", iso2: "MK", dial: "+389" },
  { name: "Norway", iso2: "NO", dial: "+47" },
  { name: "Oman", iso2: "OM", dial: "+968" },
  { name: "Pakistan", iso2: "PK", dial: "+92" },
  { name: "Palau", iso2: "PW", dial: "+680" },
  { name: "Palestine", iso2: "PS", dial: "+970" },
  { name: "Panama", iso2: "PA", dial: "+507" },
  { name: "Papua New Guinea", iso2: "PG", dial: "+675" },
  { name: "Paraguay", iso2: "PY", dial: "+595" },
  { name: "Peru", iso2: "PE", dial: "+51" },
  { name: "Philippines", iso2: "PH", dial: "+63" },
  { name: "Poland", iso2: "PL", dial: "+48" },
  { name: "Portugal", iso2: "PT", dial: "+351" },
  { name: "Puerto Rico", iso2: "PR", dial: "+1" },
  { name: "Qatar", iso2: "QA", dial: "+974" },
  { name: "Réunion", iso2: "RE", dial: "+262" },
  { name: "Romania", iso2: "RO", dial: "+40" },
  { name: "Russia", iso2: "RU", dial: "+7" },
  { name: "Rwanda", iso2: "RW", dial: "+250" },
  { name: "Saint Kitts and Nevis", iso2: "KN", dial: "+1" },
  { name: "Saint Lucia", iso2: "LC", dial: "+1" },
  { name: "Saint Martin", iso2: "MF", dial: "+590" },
  { name: "Saint Vincent and the Grenadines", iso2: "VC", dial: "+1" },
  { name: "Samoa", iso2: "WS", dial: "+685" },
  { name: "San Marino", iso2: "SM", dial: "+378" },
  { name: "Sao Tome and Principe", iso2: "ST", dial: "+239" },
  { name: "Saudi Arabia", iso2: "SA", dial: "+966" },
  { name: "Senegal", iso2: "SN", dial: "+221" },
  { name: "Serbia", iso2: "RS", dial: "+381" },
  { name: "Seychelles", iso2: "SC", dial: "+248" },
  { name: "Sierra Leone", iso2: "SL", dial: "+232" },
  { name: "Singapore", iso2: "SG", dial: "+65" },
  { name: "Sint Maarten", iso2: "SX", dial: "+1" },
  { name: "Slovakia", iso2: "SK", dial: "+421" },
  { name: "Slovenia", iso2: "SI", dial: "+386" },
  { name: "Solomon Islands", iso2: "SB", dial: "+677" },
  { name: "Somalia", iso2: "SO", dial: "+252" },
  { name: "South Africa", iso2: "ZA", dial: "+27" },
  { name: "South Korea", iso2: "KR", dial: "+82" },
  { name: "South Sudan", iso2: "SS", dial: "+211" },
  { name: "Spain", iso2: "ES", dial: "+34" },
  { name: "Sri Lanka", iso2: "LK", dial: "+94" },
  { name: "Sudan", iso2: "SD", dial: "+249" },
  { name: "Suriname", iso2: "SR", dial: "+597" },
  { name: "Sweden", iso2: "SE", dial: "+46" },
  { name: "Switzerland", iso2: "CH", dial: "+41" },
  { name: "Syria", iso2: "SY", dial: "+963" },
  { name: "Taiwan", iso2: "TW", dial: "+886" },
  { name: "Tajikistan", iso2: "TJ", dial: "+992" },
  { name: "Tanzania", iso2: "TZ", dial: "+255" },
  { name: "Thailand", iso2: "TH", dial: "+66" },
  { name: "Timor-Leste", iso2: "TL", dial: "+670" },
  { name: "Togo", iso2: "TG", dial: "+228" },
  { name: "Tonga", iso2: "TO", dial: "+676" },
  { name: "Trinidad and Tobago", iso2: "TT", dial: "+1" },
  { name: "Tunisia", iso2: "TN", dial: "+216" },
  { name: "Turkey", iso2: "TR", dial: "+90" },
  { name: "Turkmenistan", iso2: "TM", dial: "+993" },
  { name: "Turks and Caicos Islands", iso2: "TC", dial: "+1" },
  { name: "Tuvalu", iso2: "TV", dial: "+688" },
  { name: "U.S. Virgin Islands", iso2: "VI", dial: "+1" },
  { name: "Uganda", iso2: "UG", dial: "+256" },
  { name: "Ukraine", iso2: "UA", dial: "+380" },
  { name: "United Arab Emirates", iso2: "AE", dial: "+971" },
  { name: "United Kingdom", iso2: "GB", dial: "+44" },
  { name: "United States", iso2: "US", dial: "+1" },
  { name: "Uruguay", iso2: "UY", dial: "+598" },
  { name: "Uzbekistan", iso2: "UZ", dial: "+998" },
  { name: "Vanuatu", iso2: "VU", dial: "+678" },
  { name: "Vatican City", iso2: "VA", dial: "+379" },
  { name: "Venezuela", iso2: "VE", dial: "+58" },
  { name: "Vietnam", iso2: "VN", dial: "+84" },
  { name: "Western Sahara", iso2: "EH", dial: "+212" },
  { name: "Yemen", iso2: "YE", dial: "+967" },
  { name: "Zambia", iso2: "ZM", dial: "+260" },
  { name: "Zimbabwe", iso2: "ZW", dial: "+263" },
];

/** Distinct dial codes, sorted numerically, for the mobile-number step's
 * manual code override — several countries share a dial code (e.g. +1). */
export const DIAL_CODES = [...new Set(COUNTRIES.map((c) => c.dial))].sort(
  (a, b) => parseInt(a.slice(1), 10) - parseInt(b.slice(1), 10)
);

/** Just the names, for pickers that don't need the dial code (e.g. Profile).
 *  Kept here rather than duplicated per-page so the two country pickers in the
 *  app can't drift apart — they did, and adding territories to one list while
 *  the other stayed at 194 would have left Profile unable to show a country
 *  onboarding had accepted. */
export const COUNTRY_NAMES = COUNTRIES.map((c) => c.name);

/** Match key: casefolded, whitespace-collapsed, diacritics stripped — so
 *  "Reunion" finds "Réunion" and "curacao" finds "Curaçao". Mirrors `_fold()`
 *  in backend/data/countries.py; keep the two in step. */
export function foldCountry(s) {
  return (s || "")
    .split(/\s+/)
    .filter(Boolean)
    .join(" ")
    .normalize("NFD")
    .replace(/\p{Mn}/gu, "")
    .toLowerCase();
}

/** Abbreviations worth accepting, mirroring the backend's alias table. */
const ALIASES = {
  uk: "United Kingdom", "u.k.": "United Kingdom", britain: "United Kingdom",
  "great britain": "United Kingdom", england: "United Kingdom",
  scotland: "United Kingdom", wales: "United Kingdom",
  usa: "United States", us: "United States", "u.s.": "United States",
  "u.s.a.": "United States", "united states of america": "United States",
  america: "United States",
  uae: "United Arab Emirates", "u.a.e.": "United Arab Emirates",
  emirates: "United Arab Emirates",
  ksa: "Saudi Arabia", saudi: "Saudi Arabia",
};

const BY_FOLDED = new Map(COUNTRIES.map((c) => [foldCountry(c.name), c]));

export function findCountryByName(name) {
  const key = foldCountry(name);
  if (!key) return null;
  const direct = BY_FOLDED.get(key);
  if (direct) return direct;
  const aliased = ALIASES[key];
  return aliased ? BY_FOLDED.get(foldCountry(aliased)) || null : null;
}

/** Whether a typed value resolves to a real country. The onboarding step uses
 *  this to gate Continue — the field previously accepted any non-empty text,
 *  which let cities, regions and phone numbers through into Analytics. */
export function isKnownCountry(name) {
  return findCountryByName(name) !== null;
}

/** The canonical spelling for a typed value, or the trimmed input if it isn't
 *  a country (callers that must reject should use `isKnownCountry`). */
export function canonicalCountryName(name) {
  return findCountryByName(name)?.name ?? (name || "").trim();
}
